import { StudyEditFormProps } from '@/features/studies/types';
import { createContext } from 'react';

export const StudyFormContext = createContext<StudyEditFormProps | undefined>(
  undefined,
);
